import {useStyles} from '../../hooks/styles';
import {DeviceSize} from '../../theme/helpers';
import {Theme} from '../../theme/interface';

const IMAGE_SIZE_MULTIPLIER = 0.8;

export const GetStyles = (theme: Theme, headerBlockSize: number) => {
  return useStyles(({mediaOnly}) => {
    return {
      container: {
        minHeight: 152,
        backgroundColor: theme.color.blue100,
        flexDirection: 'row',
        alignItems: 'center',
        ...mediaOnly(
          DeviceSize.desktop,
          {
            borderRadius: 32,
            paddingVertical: 16,
            paddingLeft: 24,
            paddingRight: 16,
          },
          {
            borderRadius: 24,
            paddingVertical: 12,
            paddingLeft: 16,
            paddingRight: 12,
          },
        ),
      },
      imageBlock: {
        alignItems: 'center',
        justifyContent: 'center',
        width: headerBlockSize,
        height: headerBlockSize,
        borderRadius: 24,
        backgroundColor: theme.color.white,
        overflow: 'hidden',
      },
      logo: {
        position: 'relative',
        zIndex: 1,
        width: headerBlockSize * IMAGE_SIZE_MULTIPLIER,
        height: headerBlockSize * IMAGE_SIZE_MULTIPLIER,
      },
      body: {
        flexGrow: 1,
        flexShrink: 1,
        flexDirection: 'column',
        alignItems: 'stretch',
        paddingRight: 16,
      },
      name: {
        ...theme.fonts.body,
        fontFamily: theme.fonts.action.fontFamily,
        fontWeight: theme.fonts.action.fontWeight,
        color: theme.color.textColor,
      },
      descriptionContainer: {
        marginTop: 2,
      },
      description: {
        ...theme.fonts.bodySmallLight,
        color: theme.color.gray600,
      },
      phoneContainer: {
        flexGrow: 1,
        paddingHorizontal: 16,
        paddingVertical: 6,
      },
      phone: {
        justifyContent: 'center',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 10,
        marginBottom: 10,
      },
      phoneIcon: {
        width: 18,
        height: 18,
        flexShrink: 0,
        marginRight: 8,
        color: theme.color.primaryColor,
      },
      phoneText: {
        ...theme.fonts.body,
        color: theme.color.textColor,
      },
    };
  });
};
